import React from 'react';
import './new-customer.css';
import axios from 'axios';

export function NewCustomer() {

    const onNewCustomer = e => {
        e.preventDefault();
        const acId = e.target.acId.value;
        const acNm = e.target.acNm.value;
        const balance = parseFloat(e.target.balance.value);
        console.log(`Id ${acId} Name ${acNm} Bal ${balance}`);

        axios('https://www.tigerbank.store/create', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ acId, acNm, balance })
        })
        .then(payload => {
            console.log('서버 응답 payload:', payload);
        })
        .catch(error =>{
            console.error('데이터 요청이 실패하였습니다.',error);
        })
    }

    return (
        <div className="custCont">
            <div className="p--section">
                <h1> 고객 관리 - 계좌생성 </h1>
                <form onSubmit={onNewCustomer}>
                    <input type='number' placeholder='계좌 번호' name='acId'/>
                    <input type='text' placeholder='계좌명' name='acNm'/>
                    <input type='number' placeholder='잔액' name='balance'/>
                    <input type='submit' value='생성' />
                </form>
            </div>
        </div>
    );
}

export default NewCustomer;
